import { Component, Optional, Inject, OnInit } from '@angular/core';
import { IAuthorizationService, PershingTranslationService } from '@pershing/pershing-core';
import { MatDialogRef } from '@angular/material/dialog';
import { NxiConfigUtil } from '@pershing/nxi-common';
import { AboutUsDialogHeader, CustomHeader } from '../../utils/navigation.constants';
@Component({
    selector: 'about-us',
    templateUrl: './about-us.component.html'
})
export class AboutUsComponent implements OnInit{
    community: any;
    resourceEntitled: boolean = false;
    entitledForAdvisorInfo: boolean;
    entitledForAboutUs: boolean;
    entitledForContactUs: boolean;
    resourceTitle: boolean = false;
    titleId: any;
    hasAboutUs: boolean = true;
    hasContactUs: boolean = true;
    hasResources: boolean = true;
    articleId: string = "site_specific_resources";
    aboutUs: string = "about_us";
    ibd: any;
    constructor(
        private translationService: PershingTranslationService,
        @Optional() @Inject('AppSettings') appSettings: any,
        private authorizationService: IAuthorizationService,
        public dialogRef: MatDialogRef<AboutUsComponent>) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-modern-navigation', 'node_modules/@pershing/nxi-ng-modern-navigation/lib');
        this.community = NxiConfigUtil.getCommunityName(appSettings);
        this.hasResources = this.resourceEntitled = this.authorizationService.isEntitled('OUTSIDE_LINKS');
        this.entitledForAdvisorInfo = this.authorizationService.isEntitled("FINANCIAL_ADVISOR");
        this.hasAboutUs = this.entitledForAboutUs = this.authorizationService.isEntitled("ABOUT_US");
        this.hasContactUs = this.entitledForContactUs = this.authorizationService.isEntitled("CONTACT_BROKERAGE");
        this.ibd = appSettings.ibdConfigMap.IBD;
    }
    ngOnInit(): void {
        this.titleId = this.articleId;
        // customized header are replaced below.
        if (CustomHeader.propertyMap.get(this.ibd) && CustomHeader.propertyMap.get(this.ibd).get(this.articleId)) {
            this.titleId = CustomHeader.propertyMap.get(this.ibd).get(this.articleId);
        } else if (CustomHeader.propertyMap.get(this.community) && CustomHeader.propertyMap.get(this.community).get(this.articleId)) {
            this.titleId = CustomHeader.propertyMap.get(this.community).get(this.articleId);
        }
        if (AboutUsDialogHeader.propertyMap.get(this.community) && AboutUsDialogHeader.propertyMap.get(this.community).get(this.aboutUs)) {
            this.aboutUs = AboutUsDialogHeader.propertyMap.get(this.community).get(this.aboutUs);
        }
    }

    hasAboutContent(event: any) {
        this.hasAboutUs = event.hasContent;
    }

    hasContactContent(event: any) {
        this.hasContactUs = event.hasContent;
    }

    hasResourcesContent(event: any) {
        this.hasResources = event.hasContent;
    }
   
    
    
    closeDialog() {
        this.dialogRef.close();
    }
}
